import "core-js/modules/es.array.push.js";
import AgoraClient from '@/assets/js/rtc-client-ng';
import Tool, { addTabTitle, handleLocalStorage, getFullscreenEnabled, routerJump } from '@/assets/js/utils.js';
import { mapState } from 'vuex';
import Bus from '@/assets/js/bus.js';
import { controlDeviceBehavior, controlAudio, controlDevicePublish } from '@/assets/js/attendUser.js';
import VolumeBar from '@/assets/js/volumeBar.js';
export default {
  data() {
    return {
      fullRotate: false,
      hostControlPipRtilCode: {},
      firstLogoList: [],
      showUnread: false,
      allPartyMembers: [],
      showChatMessage: false,
      loadChatBox: true,
      fullScreenShareCode: '',
      shareList: {},
      blockAudioObj: {},
      blockVideoObj: {},
      allRtilList: [],
      outputSourceType: '',
      pipsListFullScreen: false,
      showCloseFullScreenBtn: false,
      initShowCloseFullScreenBtn: false,
      clearFullScreenTimer: null,
      outputRtilCode: '',
      rtilList: [],
      freeTalk: false,
      lockName: true,
      managerRtils: [],
      pgm: {},
      channels: {},
      rtc: {},
      isShare: false,
      partyCode: '',
      rtilCode: 0,
      shareInfo: {},
      inonWindow: false,
      realPartyCode: '',
      joinPartyCode: '',
      socket: null,
      MeInfo: {},
      userInfo: {},
      ckeckStatusTimer: null,
      setNameInfo: {
        show: false
      },
      repeatInfo: {
        show: false,
        title: 'common.repeatJoin',
        save: 'authorizeOperation.ok'
      },
      joinParam: {},
      behaviorInfo: {},
      talkInfo: {},
      externalPartyCode: {},
      controlMutes: {},
      hasSet: false,
      checkInitAgoraStatusTimer: null,
      CameraTips: {
        hideSave: false,
        hideCancel: false,
        showGotIt: false,
        gotIt: 'galleryParticipant.gotIt',
        title: 'galleryParticipant.cameraTips',
        content: '',
        cancel: 'galleryParticipant.deny',
        save: 'galleryParticipant.admit',
        show: false
      },
      fullScreenTips: {
        title: 'kioskHost.fullScreenAuth',
        cancel: 'galleryParticipant.deny',
        save: 'kioskHost.done',
        show: false
      },
      rtcLoaded: false,
      isPhone: false,
      initLogoList: [],
      devicesInfo: {
        cameraList: [],
        microphoneList: [],
        cameraId: '',
        microphoneId: ''
      },
      voiceList: {},
      lastAudioOperationTime: 0,
      // 用来显示快速点击的问题
      lastVideoOperationTime: 0,
      // 用来显示快速点击的问题
      initVideoPopup: true,
      initAudioPopup: true,
      hideFullTimer: null,
      outputRtilList: [],
      wsPageSTimer: null,
      rtilStatusObj: {},
      remoteNetWorks: {},
      showPipCursorPointer: true,
      showMuteIcons: true,
      showPipFullScreen: true,
      collaborateInfo: {
        show: false,
        title: 'personalInfo.Permission',
        save: 'personalInfo.accept',
        cancel: 'personalInfo.decline',
        info: {}
      },
      hadOpenWebCloud: false,
      degreeHost: {},
      globalOutputTimestamp: 0,
      partyOutputTimestamp: 0,
      viewPosition: {},
      globalControlId: '',
      isAudioLevel: false,
      oldMuteMicStatus: false,
      // 用来记录没有加入 Global Control 之前的状态
      localVolume: 0,
      hasGetTimeOffset: false,
      bestOffset: 0,
      sendMetadataTimer: {}
    };
  },
  computed: {
    returnVideoClass() {
      let _str = '';
      if (this.degreeHost[this.userInfo.rtilCode] == 0) {
        _str += 'rotate0';
      } else if (this.degreeHost[this.userInfo.rtilCode] == 90) {
        if (this.fullRotate && this.State.isVertical) {
          _str += 'rotateFull90';
        } else {
          _str += 'rotate90';
        }
      } else if (this.degreeHost[this.userInfo.rtilCode] == 180) {
        _str += 'rotate180';
      } else if (this.degreeHost[this.userInfo.rtilCode] == 270) {
        if (this.fullRotate && this.State.isVertical) {
          _str += 'rotateFull270';
        } else {
          _str += 'rotate270';
        }
      }
      return _str;
    },
    ...mapState({
      State: state => state,
      isMute: state => state.isMute,
      Config: state => state.config,
      loginInfo: state => state.loginInfo
    }),
    operateList() {
      if (this.lockName) {
        return ['fullScreen'];
      } else {
        return ['fullScreen', 'rename'];
      }
    }
  },
  watch: {
    'State.fullScreen': {
      handler: function (val) {
        if (val) {
          this.fullRotate = true;
        } else {
          this.fullRotate = false;
        }
      }
    },
    'State.showChatMessage': function () {
      this.$nextTick(() => {
        this.$refs.pipListBox && this.$refs.pipListBox.changeCanvasView('showChat');
      });
    }
  },
  async created() {
    if (!this.State.volumeBar) {
      this.State.volumeBar = new VolumeBar();
    }
    // 清除之前与会者以host的身份登录的登录信息，
    Tool.removeHostLoginInfo();
    // 添加鼠标移动监听
    window.addEventListener('mousemove', () => {
      this.showCloseFullScreenBtn = true;
      if (this.hideFullTimer) clearTimeout(this.hideFullTimer);
      this.hideFullTimer = setTimeout(() => {
        this.showCloseFullScreenBtn = false;
      }, 5000);
    });
    Tool.judgeVerticalScreen();
    window.addEventListener('resize', this.calculatorArea);
    // document.addEventListener('fullscreenerror', this.showFullScreenTips)
    // 记录与会者进入页面方式
    sessionStorage.setItem('enterPartyType', 'web');
    const {
      id
    } = this.$route.query;
    this.State.partyCode = id;
    if (/Android|webOS|iPad|iPhone|iPod|BlackBerry/i.test(navigator.userAgent) || navigator.maxTouchPoints == 5) {
      this.isPhone = true;
    }

    // 判断是setNickname还是join
    this.setNameOrJoin();
    Bus.$on('setPartyTitle', v => {
      document.title = this.$t('common.partyTitle', {
        name: v.title
      });
    });
    Bus.$on('flipVideo', v => {
      // 与会者getList(Host、anywhere)
      this.$set(this.degreeHost, v.rtilCode, v.degree);
    });
    Bus.$on('rtilLiveStatus', v => {
      this.rtilStatusObj = v;
    });
    gtag('event', 'pageView-Kiosk participate', {
      event_category: 'pageView',
      event_label: '会议模块',
      value: 'Kiosk participate'
    });
    Bus.$on('viewPositionV2', result => {
      this.viewPosition = result;
      const rtilCodes = result.total;
      // 此段代码存在会导致与会者加入后getlist接口传参为空
      // rtilCodes.forEach(v => {
      //   if (this.channels[v] && this.channels[v].shareCode == v) {
      //     this.getNickName(this.channels[v].shareInitiator, v)
      //   } else {
      //     this.getNickName(v)
      //   }
      // })

      // 是否存在live的大屏
      if (this.outputSourceType) {
        this.allRtilList = rtilCodes;
        if (this.outputSourceType == 'Pbp') {
          this.outputRtilList.forEach(val => {
            if (!this.allRtilList.includes(val.rtilCode)) {
              this.allRtilList.push(val.rtilCode);
            }
          });
        }
      } else {
        this.allRtilList = rtilCodes.concat(['mainWindow']);
      }
      // 为了 global control 添加的特殊逻辑
      // 根据 globalControl 的 output 时间和 子会议的  output 时间做对比来显示 mianwindow
      this.dealMainWindow(result);
    });
    Bus.$on('volumeList', volumeList => {
      volumeList.forEach((volume, index) => {
        this.$set(this.voiceList, volume.uid, volume);
      });
    });
    Bus.$off('moveParticipants');
    Bus.$on('moveParticipants', val => {
      if (this.userInfo.joinCode != val.originCode) return; // 如果在move过程中，这个与会者到了别的party。则move的命令此时不作处理
      const {
        originCode
      } = val;
      if (originCode == this.userInfo.joinCode) {
        val.rtilCodes.forEach(v => {
          if (v == this.userInfo.rtilCode) {
            routerJump('participate', {
              join_id: val.targetCode,
              moveParticipants: true
            });
          }
        });
      }
    });
    // host控制与会者是否重命名功能
    Bus.$on('setLoginScreenButton', async val => {
      const {
        buttonType,
        operationType
      } = val.buttonStatus;
      if (buttonType === 2) {
        // 控制与会者的底部全屏
        operationType === 0 ? this.showPipFullScreen = false : this.showPipFullScreen = true;
      } else if (buttonType === 3) {
        // 控制与会这麦克风和摄像头
        operationType === 0 ? this.showMuteIcons = false : this.showMuteIcons = true;
      } else if (buttonType === 4) {
        if (operationType === 0) {
          this.lockName = true;
          this.$message.success(this.$t('remainWords.hostLockParticipantName'));
        } else {
          this.lockName = false;
          this.$message.success(this.$t('remainWords.hostUnlockParticipantName'));
        }
      } else if (buttonType === 7) {
        if (operationType) {
          this.hadOpenWebCloud = true;
          for (const k in this.rtc) {
            this.rtc[k] && (await this.rtc[k].leave());
          }
          this.userInfo.status.cloudProxy = 1;
          this.joinAgoraClient(this.userInfo, this.userInfo.behavior, this.joinParam);
        } else if (buttonType === 17) {
          if (operationType === 0) {
            this.isAudioLevel = true;
          } else {
            this.isAudioLevel = false;
          }
        } else {
          this.hadOpenWebCloud = false;
          for (const k in this.rtc) {
            this.rtc[k] && (await this.rtc[k].leave('closeCLoudProxy'));
          }
          this.userInfo.status.cloudProxy = 0;
          this.joinAgoraClient(this.userInfo, this.userInfo.behavior, this.joinParam);
        }
      } else if (buttonType === 13) {
        this.$message.warning(this.$t('setting.muteAllParticipantsTips'));
        this.setCameraOrMic('muteAudio', '', '', false);
      } else if (buttonType === 17) {
        if (operationType === 0) {
          this.isAudioLevel = true;
        } else {
          this.isAudioLevel = false;
        }
      }
    });
    const _self = this;
    // 接收group模式下大屏视频的rtilCode
    Bus.$on('setOutput', async v => {
      const {
        sourceType,
        pbpInfo,
        outputTimestamp
      } = v;
      this.partyOutputTimestamp = outputTimestamp;
      this.outputSourceType = sourceType;

      // 先清空值
      this.outputRtilCode = '';
      this.outputRtilList = [];
      // 赋值
      if (sourceType == 'Pbp') {
        this.outputRtilList = pbpInfo.pbpSources.map(v => {
          return {
            ...v,
            rtilCode: v.rtilCode || `mainWindow${v.position}`
          };
        });
        this.outputRtilList.forEach(val => {
          if (!this.allRtilList.includes(val.rtilCode)) {
            this.allRtilList.push(val.rtilCode);
          }
        });
      } else {
        this.outputRtilCode = v.rtilCode;
      }

      // 由于viewposition的推送快于setoutput，导致viewposition的逻辑不生效，需要重新定义allRtilList的数据
      this.allRtilList = this.allRtilList.filter(v => v != 'mainWindow');
      this.State.outputCode = v.rtilCode;
    });
    Bus.$on('cancelOutput', v => {
      // const { sourceType } = v
      const _this = this;
      if (_this.globalOutputTimestamp < _this.partyOutputTimestamp) {
        this.outputSourceType = '';
        this.outputRtilCode = '';
      }
      this.outputRtilList = [];
      this.partyOutputTimestamp = v.outputTimestamp;
      this.allRtilList = this.allRtilList.filter(v => !(v + '').includes('mainWindow'));
      if (this.outputRtilCode) return;
      this.allRtilList = this.allRtilList.concat('mainWindow');
    });
    // 被调度者移除当前会议
    Bus.$off('removeParticipant');
    Bus.$on('removeParticipant', v => {
      if (v.rtilCode === _self.rtilCode) {
        _self.rtc[_self.realPartyCode].leave();
        _self.$message({
          type: 'info',
          message: 'Someone has removed you from the party.'
        });
        routerJump('remove');
      }
    });
    Bus.$on('endParty', v => {
      routerJump('remove', {
        type: 'end'
      });
    });
    Bus.$on('setBehaviors', v => {
      const behaviors = v.behaviors;
      behaviors.forEach(val => {
        if (val.key == 'nickName') {
          this.$set(this.behaviorInfo, val.mark, val.value);
          if (val.initiator && val.initiator != this.userInfo.rtilCode && val.mark == this.userInfo.rtilCode) {
            this.$message.success(this.$t('remainWords.hostModifyParticipantName'));
          }
        }
      });
    });
    Bus.$on('controlBehavior', v => {
      const {
        rtilCode,
        behavior,
        senderRtilCode
      } = v;
      const {
        key,
        value
      } = behavior;
      if (rtilCode == this.userInfo.rtilCode) {
        if (key == 'camera') {
          // 避免之后多host控制与会者device，用于记录操作host的rtilCode，以最后一次操作的host为准
          this.$set(this.hostControlPipRtilCode, 'camera', senderRtilCode);
          if (value === 'false') {
            this.setEnabledFn(false, 'video', 'host');
            this.$message.warning(this.$t('commonFunction.hasCameraOff'));
          } else {
            this.CameraTips.hideSave = false;
            this.CameraTips.hideCancel = false;
            this.CameraTips.showGotIt = false;
            this.CameraTips.show = true;
            this.CameraTips.content = `<div class="end">${this.$t('galleryParticipant.cameraTipCon')}</div>`;
          }
        }
        if (key == 'mic') {
          // 避免之后多host控制与会者device，用于记录操作host的rtilCode，以最后一次操作的host为准
          this.$set(this.hostControlPipRtilCode, 'mic', senderRtilCode);
          this.setLocalAudio(value === 'true', '', 'host');
        }
      }
      if (key == 'nickName' && this.behaviorInfo[rtilCode]) {
        this.behaviorInfo[rtilCode] = value;
      }
    });
    Bus.$on('setBackground', v => {
      if (v.url) {
        this.$refs.contentBox.style.background = `#010101 url(${v.url}) no-repeat`;
        this.$refs.contentBox.style.backgroundSize = 'cover';
      } else {
        this.$refs.contentBox.style.background = '';
      }
    });
    Bus.$on('startPrivateConversation', v => {
      const {
        rtilCode
      } = v;
      if (rtilCode === this.rtilCode) {
        this.$message({
          type: 'success',
          message: 'Production Crew has set up a private conversation with you.'
        });
      }
      this.State.privateInfo = v;
    });
    Bus.$on('videoQuality', val => {
      const {
        videoQualities
      } = val;
      for (var k in this.rtc) {
        this.rtc[k].setEncoderConfiguration(videoQualities[0]);
      }
    });
    Bus.$on('collaborateInvite', result => {
      const {
        collaborateUserId,
        status
      } = result;
      if (collaborateUserId == this.State.loginInfo.id) {
        status === 0 ? this.collaborateInfo.show = true : this.collaborateInfo.show = false;
        if (status === 0) {
          this.collaborateInfo.info = result;
        } else if (status === 2) {
          this.collaborateInfo.info = {};
        }
      }
    });
    Bus.$on('managerOnline', v => {
      if (!this.userInfo.managerRtils.includes(v.rtilCode)) {
        this.userInfo.managerRtils.push(v.rtilCode);
      }
    });
    // globalControl 相关消息推送 开始
    Bus.$on('fullScreenFromGlobalControl', v => {
      const _this = this;
      _this.$refs.pipListBox.changeFullScreen(v.operateType);
    });
    Bus.$on('startPushStreamFromGlobalControl', v => {
      const {
        outputSource,
        output,
        outputTimestamp,
        sourceType
      } = v;
      // 先清空值
      this.outputRtilList = [];
      this.outputSourceType = outputSource;
      this.outputRtilCode = output;
      if (sourceType != 'Tag') {
        this.globalOutputTimestamp = outputTimestamp;
      }
      this.State.outputCode = output;
      if (sourceType != 'Tag') {
        // 由于 viewPosition 的推送快于 setOutput，导致 viewPosition 的逻辑不生效，需要重新定义allRtilList的数据
        this.allRtilList = this.allRtilList.filter(v => v != 'mainWindow');
        this.getGlobalAgoraToken(v);
      }
    });
    Bus.$on('stopPushStreamFromGlobalControl', v => {
      const {
        partyCode,
        outputTimestamp,
        sourceType
      } = v;
      if (sourceType == 'Tag') {
        this.outputRtilCode = '';
      }
      if (this.globalOutputTimestamp > this.partyOutputTimestamp && this.viewPosition.globalControlOutput[0]) {
        this.outputSourceType = '';
        this.outputRtilCode = '';
        this.State.outputCode = '';
      }
      this.outputRtilList = [];
      if (sourceType != 'Tag') {
        this.globalOutputTimestamp = outputTimestamp;
      }
      this.allRtilList = this.allRtilList.filter(v => !(v + '').includes('mainWindow'));
      this.allRtilList = this.allRtilList.concat('mainWindow');
      if (this.rtc[partyCode]) {
        this.rtc[partyCode].leave();
        this.$delete(this.rtc, partyCode);
      }
    });
    Bus.$on('muteFromGlobalControl', v => {
      // 首先根据 val 来进行判断是 mute 还是 unmute
      const {
        partyCodes,
        operateType
      } = v;
      if (operateType) {
        // 在区分当前是 mute all 还是 mute 部分, partyCode 为空代表 mute all
        if (partyCodes.length == 0) {
          // 如果之前没有 mute 过在执行 mute 操作
          if (!this.State.globalMute || this.State.micStatus[this.userInfo.rtilCode]) {
            this.State.globalMute = true;
            this.$set(this.State.micStatus, this.userInfo.rtilCode, false);
            this.setLocalAudio(false);
          }
        } else {
          // 如果当前 mute 的是部分则有以下需要判断
          // 1. 已经 mute 过的不需要在 mute 一次
          // 2. 之前已经 mute 但不在当前 mute 列表的需要取消 mute
          const _this = this;
          if (partyCodes.includes(Number(_this.userInfo.joinCode)) && (!_this.State.globalMute || _this.State.micStatus[this.userInfo.rtilCode])) {
            this.State.globalMute = true;
            this.$set(this.State.micStatus, this.userInfo.rtilCode, false);
            this.setLocalAudio(false);
          }
        }
      } else {
        // 取消所有
        if (partyCodes.length == 0) {
          // 如果当前处于 mute 状态那么也需要执行
          if (this.State.globalMute || !this.State.micStatus[this.userInfo.rtilCode]) {
            this.State.globalMute = false;
            this.$set(this.State.micStatus, this.userInfo.rtilCode, true);
            this.setLocalAudio(true);
          }
        } else {
          // 如果当前 unmute 的是部分则有以下需要判断
          // 1. 已经 unmute 的不需要在 unmute 一次
          if (partyCodes.includes(Number(this.userInfo.joinCode)) && (this.State.globalMute || !this.State.micStatus[this.userInfo.rtilCode])) {
            this.State.globalMute = false;
            this.$set(this.State.micStatus, this.userInfo.rtilCode, true);
            this.setLocalAudio(true);
          }
        }
      }
    });
    Bus.$on('addToGlobalControl', v => {
      const {
        globalControlId,
        partyCode,
        mainWindowOutputParam,
        mute
      } = v;
      const {
        outputSource,
        output,
        outputTimestamp,
        partyOutputTimestamp
      } = mainWindowOutputParam;
      if (partyCode == this.userInfo.joinCode) {
        this.globalControlId = globalControlId;
        this.userInfo.globalControl = {};
        // 新加入时根据有没有 Global control mainWindow 来调取接口
        const _this = this;
        if (!_this.rtc[mainWindowOutputParam.partyCode] && outputTimestamp > partyOutputTimestamp) {
          this.outputSourceType = outputSource;
          this.State.outputCode = output;
          this.getGlobalAgoraToken({
            partyCode: mainWindowOutputParam.partyCode
          });
        }
        this.dealMainWindow({
          globalControlOutputTimestamp: mainWindowOutputParam.outputTimestamp,
          outputTimestamp: mainWindowOutputParam.partyOutputTimestamp,
          globalControlOutput: this.viewPosition.globalControlOutput,
          output: this.viewPosition.output
        });
        setTimeout(() => {
          this.State.pageSerBusRequestWs[this.userInfo.joinCode] && this.State.pageSerBusRequestWs[this.userInfo.joinCode].close();
          this.$delete(this.State.pageSerBusRequestWs, this.userInfo.joinCode);
        }, 2000);
        Bus.$emit('createWs', {
          ...this.State.config,
          partyCode,
          globalControlId
        });
        if (mute && this.State.micStatus[this.userInfo.rtilCode]) {
          this.setCameraOrMic('muteAudio', '', 'notNeedChange');
          this.State.globalMute = true;
        } else if (!mute && !this.State.micStatus[this.userInfo.rtilCode]) {
          this.setCameraOrMic('muteAudio', '', 'notNeedChange');
          this.State.globalMute = true;
        }
      }
    });
    Bus.$on('removeFromGlobalControl', v => {
      const {
        partyCode,
        mainWindowOutputParam,
        globalControlId
      } = v;
      const {
        outputTimestamp,
        partyOutputTimestamp
      } = mainWindowOutputParam;
      if (partyCode == this.userInfo.joinCode) {
        this.userInfo.globalControl = null;
        this.globalControlId = '';
        this.State.globalMute = false;
        this.dealMainWindow({
          globalControlOutputTimestamp: mainWindowOutputParam.outputTimestamp,
          outputTimestamp: mainWindowOutputParam.partyOutputTimestamp,
          globalControlOutput: this.viewPosition.globalControlOutput,
          output: this.viewPosition.output
        });
        setTimeout(() => {
          this.State.pageSerBusRequestWs[globalControlId] && this.State.pageSerBusRequestWs[globalControlId].close();
          this.$delete(this.State.pageSerBusRequestWs, globalControlId);
        }, 2000);
        if (outputTimestamp > partyOutputTimestamp && mainWindowOutputParam.output) {
          this.outputSourceType = '';
          this.outputRtilCode = '';
        }
        // 移除需要恢复状态
        const _this = this;
        if (_this.State.micStatus[this.userInfo.rtilCode] != _this.oldMuteMicStatus) {
          this.setCameraOrMic('muteAudio', '', 'notNeedChange');
        }
        Bus.$emit('createWs', {
          ...this.State.config,
          partyCode
        });
      }
    });
    Bus.$on('applyStreamForAll', v => {
      if (v.enable == true) return;
      const {
        output,
        outputTimestamp,
        partyCode,
        outputSource
      } = v;
      this.outputRtilCode = output;
      this.globalOutputTimestamp = outputTimestamp;
      this.viewPosition.globalControlOutputTimestamp = outputTimestamp;
      this.dealMainWindow(this.viewPosition);
      if (!this.rtc[partyCode]) {
        this.outputSourceType = outputSource;
        this.State.outputCode = output;
        if (sourceType != 'Tag') {
          this.getGlobalAgoraToken({
            partyCode
          });
        }
        // this.getGlobalAgoraToken({ partyCode })
      }
    });
    // globalControl 相关消息推送 结束
  },

  methods: {
    // globalControl 相关方法 开始
    dealMainWindow({
      globalControlOutputTimestamp,
      outputTimestamp,
      globalControlOutput,
      output
    }) {
      // 用来处理把 party 添加到 global control 时同步 mainWindow
      if (globalControlOutputTimestamp > outputTimestamp && globalControlOutput[0]) {
        this.State.outputCode = globalControlOutput[0];
        this.outputRtilCode = globalControlOutput[0];
      }
      if (outputTimestamp > globalControlOutputTimestamp && output[0]) {
        this.State.outputCode = output[0];
        this.outputRtilCode = output[0];
      }
      if (this.userInfo.globalControl) {
        if (globalControlOutputTimestamp || outputTimestamp) {
          if (globalControlOutputTimestamp > outputTimestamp) {
            this.allRtilList = this.viewPosition.total.filter(rtilCode => {
              return rtilCode != output[0];
            });
            if (!globalControlOutput[0] && !this.allRtilList.includes('mainWindow')) {
              this.allRtilList = this.allRtilList.concat(['mainWindow']);
            }
          } else {
            this.allRtilList = this.viewPosition.total.filter(rtilCode => {
              return rtilCode != globalControlOutput[0];
            });
            if (!output[0] && !this.allRtilList.includes('mainWindow')) {
              this.allRtilList = this.allRtilList.concat(['mainWindow']);
            }
          }
        }
      }
    },
    getGlobalAgoraToken(globalInfo) {
      // 先掉借口获取加入 agora 的参数
      const params = {
        memberId: handleLocalStorage('get', 'memberId') || 'PL_' + new Date().getTime(),
        partyCode: globalInfo.partyCode,
        role: 0,
        type: 3
      };
      this.axios.post('/partyline-backend/party/v2/noLogin/agoraTokenGenerate', params).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          this.joinGlobalParty(res.data.result, globalInfo);
        }
      });
    },
    async joinGlobalParty(info, globalInfo) {
      this.rtc[globalInfo.partyCode] = new AgoraClient(this.callBack);
      const {
        appId,
        tokenCode,
        rtilCode,
        videoQualities
      } = info;
      const params = {
        appId: appId,
        channel: globalInfo.partyCode + '',
        token: tokenCode,
        uid: rtilCode,
        videoConfig: videoQualities,
        publishAudio: false,
        // 始终在realparty内发流
        publishVideo: false,
        // 始终在realparty内发流
        getRemoteNetworks: true
      };
      await this.rtc[globalInfo.partyCode].join(params);
    },
    // globalControl 相关方法 结束
    controlInvite(val) {
      const params = {
        collaborateLogId: this.collaborateInfo.info.collaborateLogId,
        optionType: val ? 1 : 2
      };
      this.axios.post(`/partyline-backend/collaborate/noLogin/updateStatus?collaborateLogId=${params.collaborateLogId}&optionType=${params.optionType}`, params, {
        errorTip: false
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          if (params.optionType == 1) {
            this.$message.success(this.$t('personalInfo.acceptSuccess'));
          } else {
            this.$message.success(this.$t('personalInfo.acceptCancel'));
          }
        } else if (res.data.errorCode == '82203101') {
          this.$message.warning(this.$t('common.invitedExpire'));
        }
      });
    },
    calculatorArea() {
      Tool.judgeVerticalScreen();
      this.$refs.rightAside.resizeLogoArea();
      this.$refs.pipListBox.resizeUi(this.outputSourceType);
    },
    changeLogo(info) {
      const list = info.logos;
      this.$refs.rightAside.changeLogoList(list);
    },
    calculatorWidthHeight(logoInfo, type) {
      let {
        realX,
        realY,
        realWidth,
        realHeight
      } = logoInfo;
      if (type === 'send') {
        realX = Number((realX / this.State.kioskSideBarInfo.width * 100).toFixed(2));
        realY = Number((realY / this.State.kioskSideBarInfo.height * 100).toFixed(2));
        realWidth = Number((realWidth / this.State.kioskSideBarInfo.width * 100).toFixed(2));
        realHeight = Number((realHeight / this.State.kioskSideBarInfo.height * 100).toFixed(2));
      } else {
        realX = Number((realX * this.State.kioskSideBarInfo.width / 100).toFixed(0));
        realY = Number((realY * this.State.kioskSideBarInfo.height / 100).toFixed(0));
        realWidth = Number((realWidth * this.State.kioskSideBarInfo.width / 100).toFixed(0));
        realHeight = Number((realHeight * this.State.kioskSideBarInfo.height / 100).toFixed(0));
      }
      return {
        realX,
        realY,
        realWidth,
        realHeight
      };
    },
    pageSerBusCallback({
      socket,
      partyCode
    }) {
      this.wsPageSTimer = setInterval(() => {
        if (this.$route.name != 'kioskParticipate') clearInterval(this.wsPageSTimer);

        // 发送liveRtilCodes
        const params = {
          data: JSON.stringify({
            data: JSON.stringify({
              rtilCodes: this.allRtilList.filter(v => !(v + '').includes('mainWindow')),
              businessId: partyCode
            }),
            module: 'rtilLiveStatus',
            type: 'rtilLiveStatus'
          }),
          serverName: 'partyline'
        };
        if (socket.client.readyState === 1 && this.$route.name == 'kioskParticipate') {
          socket.send(params);
        }
      }, 1000);
    },
    dealFootEvent(info) {
      const {
        type,
        val
      } = info;
      switch (type) {
        case 'muteVideo':
        case 'muteAudio':
          this.setCameraOrMic(type, '', '', val);
          break;
        case 'changeDevice':
          this.changeDevice(val);
          break;
        case 'changeMute':
          this.changeMute(val);
          break;
        case 'showChat':
          this.State.showChatMessage = val;
          break;
        case 'fullScreen':
          this.fullScreenFn();
          break;
        case 'leave':
          Bus.$emit('showDialog', {
            show: true,
            realPartyCode: this.realPartyCode,
            externalPartyCode: this.externalPartyCode,
            rtilCode: this.userInfo.rtilCode
          });
          break;
      }
    },
    chatCallback({
      type,
      rtilCode,
      data
    }) {
      if (type == 'nickName') {
        this.getNickName(rtilCode);
      }
      if (type == 'unreadInfo') {
        this.showUnread = false;
        Object.keys(data).forEach(keys => {
          if (data[keys].unRead) {
            this.showUnread = true;
          }
        });
      }
    },
    async getBehaviorsByMemberId() {
      if (!this.$route.query.id.trim()) return;
      const params = {
        memberId: handleLocalStorage('get', 'memberId') || 'PL_' + new Date().getTime(),
        annotation: this.$route.query.id.trim(),
        keys: ['nickName']
      };
      handleLocalStorage('set', 'memberId', params.memberId);
      const res = await this.axios.post('/partyline-backend/behavior/noLogin/getListByMemberId', params);
      const result = res.data.result;
      const {
        rtilCode,
        behaviors
      } = result;
      if (res.data.errorCode == '0x0' && rtilCode) {
        this.behaviorInfo[rtilCode] = behaviors[rtilCode].nickName;
      }
      return rtilCode;
    },
    async setNameOrJoin() {
      const rtilCode = await this.getBehaviorsByMemberId();
      if (rtilCode && this.behaviorInfo[rtilCode]) {
        this.joinPartyLine(); // 有rtilCode代表设置过nickName
      } else {
        routerJump('preview', {
          id: this.State.partyCode
        });
      }
    },
    fullScreenFn() {
      this.pipsListFullScreen = !this.pipsListFullScreen;
      if (this.pipsListFullScreen) {
        this.showChat = false;
        this.showCloseFullScreenBtn = true;
        this.initShowCloseFullScreenBtn = true;
        this.clearFullScreenTimer = setTimeout(() => {
          this.showCloseFullScreenBtn = false;
          this.initShowCloseFullScreenBtn = false;
        }, 1000 * 5);
      } else {
        clearTimeout(this.clearFullScreenTimer);
        this.clearFullScreenTimer = null;
        this.initShowCloseFullScreenBtn = true;
        this.showCloseFullScreenBtn = false;
      }
    },
    showFullScreenCloseBtnFn(val) {
      if (this.initShowCloseFullScreenBtn) return; // 初始化显示5s之后，在执行其他操作
      this.showCloseFullScreenBtn = val;
    },
    getOnlineMember() {
      this.axios.get('/partyline-backend/kiosk/noLogin/getViewRtilCodes', {
        params: {
          partyCode: this.$route.query.id
        }
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          var _res$data$result$view;
          const list = (_res$data$result$view = res.data.result.viewPosition) === null || _res$data$result$view === void 0 ? void 0 : _res$data$result$view.total;
          this.viewPosition = res.data.result.viewPosition;
          this.allRtilList = list.map(v => {
            if (!this.channels[v]) {
              this.$set(this.channels, v, {
                id: v
              });
            }
            this.getNickName(v);
            return v;
          });
          if (!this.outputSourceType) {
            this.allRtilList = this.allRtilList.concat(['mainWindow']);
          }
          if (this.outputSourceType == 'Pbp') {
            this.outputRtilList.forEach(val => {
              if (!this.allRtilList.includes(val.rtilCode)) {
                this.allRtilList.push(val.rtilCode);
              }
            });
          }
          // 为了 global control 添加的特殊逻辑
          this.dealMainWindow(this.viewPosition);
        }
      });
    },
    muteAudioOrVideo(action, payload) {
      const {
        id,
        mediaType
      } = payload;
      const val = action === 'user-published';
      mediaType === 'video' ? this.$set(this.State.cameraStatus, id, val) : this.$set(this.State.micStatus, id, val);
    },
    async getNickName(id, key) {
      if (!this.userInfo.joinCode) return;
      await this.axios.post('/partyline-backend/behavior/noLogin/getList', {
        originRtilCode: this.userInfo.rtilCode,
        annotation: this.userInfo.joinCode,
        keys: ['nickName', 'flipVideo'],
        marks: [id]
      }).then(res => {
        if (!res) return;
        if (res.data.errorCode === '0x0') {
          const result = res.data.result[id];
          if (this.userInfo.managerRtils && (this.userInfo.managerRtils.includes(parseInt(id)) || this.userInfo.managerRtils.includes(parseInt(key)))) {
            result.nickName = result.nickName || 'host';
          }
          if (key) {
            this.$set(this.behaviorInfo, key, result.nickName);
          } else {
            this.$set(this.degreeHost, id, result.flipVideo);
            this.$set(this.behaviorInfo, id, result.nickName);
          }
        }
      });
    },
    changeDevice(obj) {
      if (obj.type == 'speaker') {
        handleLocalStorage('set', 'speakerId', obj.deviceId);
        // host切换
        this.$nextTick(() => {
          this.userInfo.managerRtils.forEach(val => {
            if (this.$refs[`remoteHost${val}`]) {
              this.$refs[`remoteHost${val}`][0] && this.$refs[`remoteHost${val}`][0].setSpeakerAttendUser();
            }
          });
        });
        // 与会者切换
        this.$refs.pipListBox.setPipUser();
      }
      if (!this.isPhone) {
        Object.keys(this.rtc).forEach(key => {
          this.rtc[key] && this.rtc[key].setDevice(obj.deviceId, obj.type, result => {
            if (obj.type === 'audio' && result === 'success') {
              var _this$$refs$localVide, _this$$refs$localVide2;
              (_this$$refs$localVide = this.$refs.localVideo) === null || _this$$refs$localVide === void 0 ? void 0 : (_this$$refs$localVide2 = _this$$refs$localVide.reAddAudioContext) === null || _this$$refs$localVide2 === void 0 ? void 0 : _this$$refs$localVide2.call(_this$$refs$localVide);
            }
          });
        });
      }
    },
    TurnTips(flag, tag) {
      // 无摄像头
      let msg = '';
      if (tag === 'camera' && !this.devicesInfo.cameraId || tag === 'microphone' && !this.devicesInfo.microphoneId) {
        msg = 'No access';
      } else {
        const onOroff = flag ? this.$t('operationBtn.on') : this.$t('operationBtn.off');
        msg = `${onOroff} ${tag}`;
      }
      return msg;
    },
    setCameraStatus(val) {
      this.$set(this.State.cameraStatus, this.userInfo.rtilCode, true);
      this.setEnabledFn(true, 'video', 'host');
    },
    sendToHost(type, value) {
      const params = {
        module: 'responseControlBehavior',
        partyCode: this.State.partyCode,
        origin: 'kioskParticipate',
        msg: {
          key: type,
          senderRtilCode: this.userInfo.rtilCode,
          rtilCode: this.hostControlPipRtilCode[type],
          responseCode: value
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=30220', params);
    },
    attendCallback({
      type,
      val
    }) {
      if (type == 'muteAudio' || type == 'muteVideo') {
        this.setCameraOrMic(type, '', '', val);
      } else if (type === 'fullScreen') {
        this.State.fullScreen = val;
        if (val && getFullscreenEnabled()) {
          document.documentElement.requestFullscreen && document.documentElement.requestFullscreen();
        }
      } else if (type === 'audioContext') {
        this.localVolume = val;
      }
    },
    setNickName(data) {
      this.joinPartyLine('', data);
    },
    userJoin(payload) {
      if (!payload.id) return;
      // 初始化camera和miro的状态
      if (this.State.cameraStatus[payload.id] != false) {
        this.$set(this.State.cameraStatus, payload.id, true);
      }
      if (this.State.micStatus[payload.id] != false) {
        this.$set(this.State.micStatus, payload.id, true);
      }
      this.axios.post(`/partyline-backend/member/noLogin/queryByRtilCode/${payload.id}`).then(res => {
        if (res.data.errorCode == '0x0') {
          const accountId = res.data.result.accountId.toLowerCase();

          // 判断是不是share的code,获取nickName
          let shareInitiator = '';
          let shareCode = '';
          if (accountId.indexOf('_sharescreen') > -1) {
            // 获取是谁发起的share的code
            shareCode = payload.id;
            shareInitiator = accountId.split('_sharescreen')[0];
            this.$set(this.shareList, shareCode, shareInitiator);
            this.getNickName(shareInitiator, payload.id);
          } else {
            this.getNickName(payload.id);
            if (!this.allPartyMembers.includes(payload.id)) {
              this.allPartyMembers.push(payload.id);
            }
          }
          const obj = Object.assign({}, this.channels[payload.id]);
          this.$set(this.channels, payload.id, {
            ...payload,
            ...obj,
            tid: res.data.result.accountId,
            shareInitiator,
            shareCode
          });
        }
      });
    },
    async subscribeTrack(payload) {
      try {
        const {
          videoTrack,
          audioTrack
        } = payload;
        let obj = {};
        obj = Object.assign({}, this.channels[payload.id], {
          id: payload.id
        }, {
          channel: payload.channel
        });
        obj.videoTrack = videoTrack;
        obj.audioTrack = audioTrack;
        this.$set(this.channels, payload.id, obj);
        // 如果私聊是自己，需要mute掉没在和自己私聊的host的声音
        if (this.State.privateInfo.rtilCode == this.userInfo.rtilCode) {
          this.managerRtils.forEach(v => {
            if (v != this.State.privateInfo.crewRtilCode) {
              this.$set(this.controlMutes, v, true);
            } else {
              this.$set(this.controlMutes, v, false);
            }
          });
        }
        // 如果存在别人在私聊，则需要mute掉私聊的host声音
        if (this.State.privateInfoByOthers.length) {
          this.State.privateInfoByOthers.forEach(v => {
            if (v.rtilCode != this.userInfo.rtilCode) {
              this.$set(this.controlMutes, v.crewRtilCode, true);
            }
          });
        }
      } catch (error) {}
    },
    userLeave(payload) {
      const {
        id
      } = payload;
      // 保留id目的是为了再次加入的时候会显示loding效果
      this.$set(this.channels, id, {
        id
      });
      // chat人员
      this.allPartyMembers = this.allPartyMembers.filter(v => v != payload.id);
    },
    joinPartyLine(newRealPartyCode, behavior) {
      this.bestOffset = 0;
      this.hasGetTimeOffset = false;
      if (this.socket) {
        this.socket.close(); // 手动停止websocket
        this.socket = null;
        if (this.updataInfoTimer) clearInterval(this.updataInfoTimer);
      }
      if (newRealPartyCode) {
        setTimeout(() => {
          this.joinRequest(newRealPartyCode, behavior);
        }, 1000);
      } else {
        this.joinRequest(newRealPartyCode, behavior);
      }
    },
    joinRequest(newRealPartyCode, behaviors) {
      const partyCode = this.$route.query.id;
      const haveHistoryMem = handleLocalStorage('get', 'memberId');
      const params = {
        memberId: haveHistoryMem || 'PL_' + new Date().getTime(),
        partyCode: partyCode,
        role: 0,
        type: 0,
        specifyPartyCode: newRealPartyCode || '',
        specifyRtilCode: newRealPartyCode ? +handleLocalStorage('get', 'rtilCode') : '',
        host: false,
        behaviorKeyList: ['hearSelf', 'speaker', 'nickName', 'mic', 'camera', 'audioOnlyType', 'checkAudioMainWindow', 'checkAudioShare', 'enableControlMedia', 'flipVideo']
      };
      if (behaviors) params.behaviors = behaviors;
      this.axios.post('/partyline-backend/party/noLogin/join', params, {
        routeName: this.$route.query.from,
        errorTip: false
      }).then(async res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          this.State.partyJoinInfo = result;
          const {
            status,
            behavior,
            externalJoinInfo,
            rtilCode
          } = result;
          // 创建通知websocket
          if (!this.State.pageSerBusRequestWs[this.State.partyCode]) {
            if (result.globalControl) {
              this.globalControlId = result.globalControl.id;
              Bus.$emit('createWs', {
                ...this.State.config,
                partyCode: result.joinCode,
                globalControlId: result.globalControl.id
              });
            } else {
              Bus.$emit('createWs', {
                ...this.State.config,
                partyCode: result.joinCode
              });
            }
          }
          result.status.volumeEffect === 0 ? this.isAudioLevel = true : this.isAudioLevel = false;
          addTabTitle({
            userInfo: result
          });
          this.joinParam = {
            ...result,
            partyCode: partyCode,
            memberId: params.memberId
          };
          this.$set(this.degreeHost, result.rtilCode, behavior.flipVideo);
          this.allPartyMembers.unshift(result.rtilCode);
          this.userInfo = res.data.result;
          this.realPartyCode = this.userInfo.realPartyCode;
          this.externalPartyCode = externalJoinInfo.join;
          this.State.outputCode = status.output;
          this.State.joinInfo = result;
          this.State.globalMute = status.globalControlMute === '1';
          this.rtilCode = rtilCode;
          this.showPipFullScreen = status.fullScreen !== 0;
          this.showMuteIcons = status.micCameraIconInPip !== 0;
          // audioOnly 状态记录
          this.State.audioType = behavior.audioOnlyType ? Number(behavior.audioOnlyType) : 0;
          this.State.checkMainWindow = behavior.checkAudioMainWindow !== 'false';
          this.State.checkShareScreen = behavior.checkAudioShare !== 'false';
          Bus.$emit('changeAudioTypeVal');
          // 控制与会者的重命名
          status.lockName === 0 ? this.lockName = true : this.lockName = false;
          if (status.outputSource == 'Pbp') {
            this.outputRtilList = status.multiOutput.pbpSources.map(v => {
              return {
                ...v,
                rtilCode: v.rtilCode || `mainWindow${v.position}`
              };
            });
          } else {
            this.outputRtilCode = status.output; // 关闭页面需要后台定时清除，share状态不准确
          }
          // 处理pipoutput
          this.outputSourceType = status.outputSource; // share根据rtilCOde查询memberId，状态准确
          // globalControl 的情况下再去执行以下代码
          if (result.globalControl) {
            const {
              outputSource,
              output,
              fullScreen
            } = result.globalControl;
            if (output) {
              this.globalOutputTimestamp = result.globalControl && result.globalControl.outputTimestamp;
              this.partyOutputTimestamp = result.status.outputTimestamp || 0;
              if (this.globalOutputTimestamp > this.partyOutputTimestamp || !this.partyOutputTimestamp) {
                this.outputSourceType = outputSource;
                this.outputRtilCode = output;
                this.State.outputCode = output;
                this.State.globalisFullScreen = fullScreen;
                this.getGlobalAgoraToken(result.globalControl);
              }
            }
          }
          this.getOnlineMember();
          this.rtc[result.realPartyCode] = new AgoraClient(this.callBack);
          this.devicesInfo = await this.rtc[result.realPartyCode].getDevice();
          if (!handleLocalStorage('get', 'speakerId')) {
            handleLocalStorage('set', 'speakerId', this.devicesInfo.speakerId);
          }

          // 新增为了上传logo
          if (status.logos) {
            status.logos.logos.forEach(item => {
              item.active = true;
              const {
                realX,
                realY,
                realWidth,
                realHeight
              } = this.calculatorWidthHeight(item, 'resume');
              item.realX = realX;
              item.realY = realY;
              item.realWidth = realWidth;
              item.realHeight = realHeight;
              this.State.hadSelectUpLogo.push(item.name);
            });
            this.firstLogoList = status.logos.logos;
          } else {
            this.firstLogoList = [];
          }
          if (status.background) {
            status.background.active = true;
            this.State.hadSelectUpBg = status.background;
            this.$refs.contentBox.style.background = `#010101 url(${status.background.url}) no-repeat`;
            this.$refs.contentBox.style.backgroundSize = 'cover';
          }

          // layoutName
          this.layoutName = result.layoutName;
          this.State.groupLayout.layoutName = result.layoutName;
          this.freeTalk = false;
          if (this.layoutName == '2-2') {
            this.freeTalk = status.freeTalk == true;
          }

          // 自己是否在私聊
          if (status.privateConversation) {
            this.State.privateInfo = JSON.parse(status.privateConversation);
          } else {
            this.State.privateInfo = {};
          }

          // 是否存在别人在私聊
          if (!this.State.privateInfoByOthers.length) {
            if (status.privateConversations) {
              this.State.privateInfoByOthers = JSON.parse(status.privateConversations);
            } else {
              this.State.privateInfoByOthers = [];
            }
          }
          Bus.$emit('changePartyAddress', {
            currentId: partyCode,
            title: result.title
          });
          // 用于向别的组件传递初始化数据
          Bus.$emit('updateInitStatus', {
            hasCopy: result.status.hasCopy !== 0,
            loginButton: result.status.loginButton !== 0
          });
          if (behavior && behavior.nickName) {
            const nickName = behavior.nickName;
            this.$set(this.behaviorInfo, this.userInfo.rtilCode, nickName);
            behavior.speaker = behavior.speaker !== 'false';
            behavior.camera = behavior.camera !== 'false';
            behavior.mic = behavior.mic !== 'false';
            this.oldMuteMicStatus = behavior.mic !== 'false';
            this.joinAgoraClient(result, behavior, this.joinParam);
          }
          this.getChatMettingInfo(result, behavior);
        } else if (res.data.errorCode === '80520103') {
          var _this$Config$urlInfo;
          const userServerUrl = (_this$Config$urlInfo = this.Config.urlInfo) === null || _this$Config$urlInfo === void 0 ? void 0 : _this$Config$urlInfo.userservice;
          const publicPath = this.State.publicPath || 'partyline';
          window.location.href = `${userServerUrl}/?url=${location.protocol}//${location.host}/${publicPath}?join_id=${this.joinPartyCode}&serviceName=Partyline`;
        } else if (res.data.errorCode === '80520104') {
          routerJump('remove', {
            type: 'noCommonpartyPermission'
          });
        } else if (res.data.errorCode === '82201504') {
          routerJump('remove', {
            type: 'disableParty'
          });
        } else if (res.data.errorCode === '82200603') {
          routerJump('remove', {
            type: 'fullParty',
            number: res.data.errorInfo
          });
        } else if (res.data.errorCode === '80520113') {
          this.$message.error(this.$t('partyInfo.partyDisabled'));
        }
      }).catch(err => {
        console.info(err);
        if (err.status === 400) {
          this.$message.error(this.$t('remainWords.partyNotExist'));
          routerJump('joinPage');
        }
      });
    },
    joinAgoraClient(result, obj, param) {
      if (this.rtc[result.realPartyCode]) this.rtc[result.realPartyCode].leave();
      // Me设置私聊功能，使用到
      this.MeInfo = {
        id: result.rtilCode,
        tid: handleLocalStorage('get', 'memberId'),
        info: {
          rtilCode: result.rtilCode
        },
        channel: this.realPartyCode
      };
      this.State.isMute = !obj.speaker;
      // 如果没有摄像头，则默认图标禁用
      this.$set(this.State.micStatus, this.userInfo.rtilCode, this.devicesInfo.microphoneId ? obj.mic : false);
      this.oldMuteMicStatus = this.devicesInfo.microphoneId ? obj.mic : false;
      this.$set(this.State.cameraStatus, this.userInfo.rtilCode, this.devicesInfo.cameraId ? obj.camera : false);
      handleLocalStorage('set', 'rtilCode', result.rtilCode);
      handleLocalStorage('set', 'manageRtilCode', result.managerRtils);
      this.managerRtils = result.managerRtils;

      // join client
      this.getMeetingInfo(param, result, obj);
    },
    async callBack({
      action,
      payload
    }) {
      const {
        changeDevice
      } = payload;
      switch (action) {
        case 'user-joined':
          this.userJoin(payload);
          break;
        case 'subscribe-track':
          this.subscribeTrack(payload);
          break;
        case 'subscribe-video':
          Bus.$emit('setSubscribeTrack', payload);
          break;
        case 'unlinkQuality':
          this.unlinkQuality(payload);
          break;
        case 'user-left':
          this.userLeave(payload);
          break;
        case 'user-published':
        case 'user-unpublished':
          this.muteAudioOrVideo(action, payload);
          break;
        case 'local-publish':
          if (payload.type.includes('audio')) {
            this.$set(this.State.micStatus, this.userInfo.rtilCode, true);
            this.oldMuteMicStatus = false;
          }
          if (payload.type.includes('video')) {
            this.$set(this.State.cameraStatus, this.userInfo.rtilCode, true);
          }
          break;
        case 'local-unpublish':
          if (payload.type.includes('audio')) {
            this.$set(this.State.micStatus, this.userInfo.rtilCode, false);
            this.oldMuteMicStatus = true;
          }
          if (payload.type.includes('video')) {
            this.$set(this.State.cameraStatus, this.userInfo.rtilCode, false);
          }
          break;
        case 'connection-state-change':
          // 代表有人重复加入
          if (payload.reason === 'UID_BANNED') {
            this.repeatInfo.show = true;
          }
          break;
        case 'cameraChange':
          if (!this.rtc || !this.rtc[this.realPartyCode]) return;
          this.devicesInfo = await this.rtc[this.realPartyCode].getDevice();
          if (this.rtc[this.realPartyCode]._localVideoTrack && changeDevice.device.label === this.rtc[this.realPartyCode]._localVideoTrack.getTrackLabel()) {
            const oldCameras = await this.rtc[this.realPartyCode]._AgoraRTC.getCameras();
            oldCameras[0] && this.rtc[this.realPartyCode].setDevice(oldCameras[0].deviceId, 'video', type => {
              type === 'success' ? this.$message.success(this.$t('common.autoSwitchNewCameraSuccess')) : this.$message.error(this.$t('common.autoSwitchNewCameraFailed'));
              this.devicesInfo.cameraId = oldCameras[0].deviceId;
            });
          }
          break;
        case 'micChange':
          if (!this.rtc || !this.rtc[this.realPartyCode]) return;
          this.devicesInfo = await this.rtc[this.realPartyCode].getDevice();
          if (this.rtc[this.realPartyCode]._localAudioTrack && (this.rtc[this.realPartyCode]._localAudioTrack._deviceName.includes(changeDevice.device.label) || changeDevice.state === 'INACTIVE' && this.rtc[this.realPartyCode]._localAudioTrack._config.microphoneId == 'default')) {
            const oldMic = await this.rtc[this.realPartyCode]._AgoraRTC.getMicrophones();
            oldMic[0] && this.rtc[this.realPartyCode].setDevice(oldMic[0].deviceId, 'audio', type => {
              var _this$$refs$localVide3, _this$$refs$localVide4;
              type === 'success' ? this.$message.success(this.$t('common.autoSwitchNewMicSuccess')) : this.$message.error(this.$t('common.autoSwitchNewMicFailed'));
              this.devicesInfo.microphoneId = oldMic[0].deviceId;
              (_this$$refs$localVide3 = this.$refs.localVideo) === null || _this$$refs$localVide3 === void 0 ? void 0 : (_this$$refs$localVide4 = _this$$refs$localVide3.reAddAudioContext) === null || _this$$refs$localVide4 === void 0 ? void 0 : _this$$refs$localVide4.call(_this$$refs$localVide3);
            });
          } else if (changeDevice.state === 'ACTIVE' && this.rtc[this.realPartyCode]._localAudioTrack && !this.rtc[this.realPartyCode]._localAudioTrack._deviceName.includes(changeDevice.device.label) && this.rtc[this.realPartyCode]._localAudioTrack._config.microphoneId != 'default') {
            var _this$$refs$localVide5, _this$$refs$localVide6;
            // 插入mic
            if (this.State.micStatus[this.userInfo.realPartyCode]) {
              this.rtc[this.userInfo.realPartyCode].setEnabled(false, 'audio');
              this.rtc[this.userInfo.realPartyCode].setEnabled(true, 'audio');
            }
            (_this$$refs$localVide5 = this.$refs.localVideo) === null || _this$$refs$localVide5 === void 0 ? void 0 : (_this$$refs$localVide6 = _this$$refs$localVide5.reAddAudioContext) === null || _this$$refs$localVide6 === void 0 ? void 0 : _this$$refs$localVide6.call(_this$$refs$localVide5);
            if (this.devicesInfo.microphoneList[0].label != this.rtc[this.realPartyCode]._localAudioTrack._deviceName) {
              this.$message.success(this.$t('common.autoSwitchNewMicSuccess'));
            }
          }
          break;
        case 'playbackChange':
          const rtc = this.rtc[this.userInfo.realPartyCode];
          if (!rtc) return;
          if (typeof HTMLAudioElement.prototype.setSinkId === 'undefined') {
            this.$t('common.notSupportSwitchSpeaker');
            return;
          }
          if (changeDevice.state !== 'ACTIVE' && rtc._localAudioTrack) {
            const currentDeviceId = handleLocalStorage('get', 'speakerId');
            const currentLabelArray = this.devicesInfo.speakerList.filter(item => item.deviceId == currentDeviceId);
            const currentSpeakerList = await rtc._AgoraRTC.getPlaybackDevices();
            const haveUseDevice = currentSpeakerList.find(item => item.label == currentLabelArray[0].label);
            if (!haveUseDevice) {
              handleLocalStorage('set', 'speakerId', currentSpeakerList[0].deviceId);
              const array = Object.keys(this.channels).filter(rtilCode => {
                return rtilCode != this.userInfo.rtilCode;
              });
              array.forEach(rtilCode => {
                if (this.channels[rtilCode].audioTrack) {
                  var _this$channels$rtilCo, _this$channels$rtilCo2;
                  (_this$channels$rtilCo = (_this$channels$rtilCo2 = this.channels[rtilCode].audioTrack).setPlaybackDevice) === null || _this$channels$rtilCo === void 0 ? void 0 : _this$channels$rtilCo.call(_this$channels$rtilCo2, currentSpeakerList[0].deviceId);
                }
              });
            }
          }
          this.devicesInfo = await rtc.getDevice();
          break;
      }
    },
    // 用于监听远端用户网络质量
    unlinkQuality(payload) {
      if (!payload.type) return;
      this.$set(this.remoteNetWorks, payload.id, {
        uplinkNetworkQuality: payload.uplinkNetworkQuality,
        downlinkNetworkQuality: payload.downlinkNetworkQuality
      });
    },
    async getMeetingInfo(param, result) {
      result = JSON.parse(JSON.stringify(result));
      const {
        appId,
        tokenCode,
        rtilCode,
        realPartyCode,
        videoQualities
      } = param;
      const params = {
        appId: appId,
        channel: realPartyCode + '',
        token: tokenCode,
        uid: rtilCode,
        codec: 'h264',
        cameraId: this.devicesInfo.cameraId,
        microphoneId: this.devicesInfo.microphoneId,
        videoConfig: videoQualities,
        publishAudio: this.State.micStatus[rtilCode],
        // 始终在realparty内发流
        publishVideo: this.State.cameraStatus[rtilCode],
        // 始终在realparty内发流
        getRemoteNetworks: true,
        startProxy: result.status.cloudProxy === 1,
        executeLocalSubscribe: true,
        executeVideoAdded: true,
        video: !!this.devicesInfo.cameraId && this.State.cameraStatus[rtilCode],
        audio: !!this.devicesInfo.microphoneId && this.State.micStatus[rtilCode]
      };
      if (param.status.globalControlMute === '1') params.publishAudio = false;
      const uid = await this.rtc[realPartyCode].join(params);
      if (uid) {
        var _this$userInfo$videoQ, _this$userInfo$videoQ2;
        this.hadOpenWebCloud = result.status.cloudProxy === 1;
        this.rtcLoaded = true;
        this.rtc[realPartyCode]._client && this.rtc[realPartyCode]._client.enableAudioVolumeIndicator();
        this.$set(this.channels, rtilCode, {
          channel: realPartyCode,
          id: rtilCode,
          remoteStream: this.rtc[realPartyCode]._localStream
        });
        this.joinPartyCode = result.joinCode;
        if (this.State.globalMute && this.State.micStatus[this.userInfo.rtilCode]) {
          this.$set(this.State.micStatus, this.userInfo.rtilCode, false);
          this.setLocalAudio(false);
        }
        this.State.currentRtilCode = rtilCode;
        // 新增和用户行为的对比，以防止网络不好的时候无法状态统一
        if (this.checkInitAgoraStatusTimer) clearTimeout(this.checkInitAgoraStatusTimer);
        /// 更改hostjr userId
        const userId = rtilCode + '_' + this.behaviorInfo[this.MeInfo.id] + '_' + this.realPartyCode;
        window.hj && window.hj('identify', userId, {
          timeStamp: Date.now()
        });
        if (!this.hasGetTimeOffset) {
          const offset = await this.dealTimeOffset();
          this.bestOffset = offset;
          this.hasGetTimeOffset = true;
        }
        const fps = (_this$userInfo$videoQ = this.userInfo.videoQualities) === null || _this$userInfo$videoQ === void 0 ? void 0 : (_this$userInfo$videoQ2 = _this$userInfo$videoQ[0]) === null || _this$userInfo$videoQ2 === void 0 ? void 0 : _this$userInfo$videoQ2.fps;
        const intervalTime = fps ? Math.round(1000 / fps) : 33;
        if (this.sendMetadataTimer[realPartyCode]) clearInterval(this.sendMetadataTimer[realPartyCode]);
        this.sendMetadataTimer[realPartyCode] = setInterval(() => {
          this.sendMetadata(realPartyCode);
        }, intervalTime);
      }
    },
    async dealTimeOffset() {
      let bestRTT = Infinity;
      let bestOffset = 0;
      for (var i = 0; i < 10; i++) {
        const t0 = Date.now();
        const serverTime = await this.getTimeOffset();
        const t1 = Date.now();
        const rtt = t1 - t0;
        const offset = Date.now() - (serverTime + Math.round(rtt / 2));
        if (rtt < bestRTT) {
          bestRTT = rtt;
          bestOffset = offset;
        }
      }
      return bestOffset;
    },
    async getTimeOffset() {
      return await this.axios.get('/partyline-backend/base/getServerTime').then(res => {
        return res.data;
      });
    },
    sendMetadata(realPartyCode) {
      var _this$rtc$realPartyCo, _this$rtc$realPartyCo2;
      if (!((_this$rtc$realPartyCo = this.rtc[realPartyCode]) !== null && _this$rtc$realPartyCo !== void 0 && _this$rtc$realPartyCo.hasJoined)) return;
      const params = {
        offset: this.bestOffset,
        rtilCode: this.rtilCode,
        timestamp: Date.now() + this.bestOffset
      };
      (_this$rtc$realPartyCo2 = this.rtc[realPartyCode]._client) === null || _this$rtc$realPartyCo2 === void 0 ? void 0 : _this$rtc$realPartyCo2.sendMetadata(new TextEncoder().encode(JSON.stringify(params)), function (error) {
        if (error) console.log('sendMetadata', error);
      });
    },
    changeMute(flag) {
      this.$store.dispatch('isMute', !this.isMute);
      if (flag) {
        this.$message({
          type: 'success',
          message: this.$t('galleryParticipant.websiteSoundOff')
        });
      } else {
        this.$message({
          type: 'success',
          message: this.$t('galleryParticipant.websiteSoundOn')
        });
      }
      this.changeBehaviorStatus('speaker', !this.isMute);
    },
    async setCameraOrMic(type, notNeedJudge, notNeedChange, val) {
      const timeStamp = Date.now();
      this.hasSet = true;
      if (type === 'muteVideo') {
        if (!this.devicesInfo.cameraId) {
          if (this.devicesInfo.cameraError == 'PERMISSION_DENIED') {
            this.State.guideObjShow = true;
          } else {
            this.$message.error('No camera available');
          }
          return;
        }
        if (timeStamp - this.lastVideoOperationTime < 1000) {
          if (this.initVideoPopup) {
            this.initVideoPopup = !this.initVideoPopup;
            this.$message.warning(this.$t('commonFunction.notOperateFrequery'));
          }
          return;
        } else {
          this.initVideoPopup = true;
        }
        this.lastVideoOperationTime = timeStamp;
        this.setEnabledFn(val, 'video');
      } else {
        if (!this.devicesInfo.microphoneId) {
          if (this.devicesInfo.microphoneError == 'PERMISSION_DENIED') {
            this.State.guideObjShow = true;
          } else {
            this.$message.error('No microphone available');
          }
          return;
        }
        // 为了 global control 模式添加
        if (this.State.globalMute && !notNeedJudge) {
          this.$message.warning(this.$t('common.failedInGlobal'));
          return;
        }
        if (timeStamp - this.lastAudioOperationTime < 1000) {
          if (this.initAudioPopup) {
            this.initAudioPopup = !this.initAudioPopup;
            this.$message.warning(this.$t('commonFunction.notOperateFrequery'));
          }
          return;
        } else {
          this.initAudioPopup = true;
        }
        this.lastAudioOperationTime = timeStamp;
        if (!notNeedChange) this.oldMuteMicStatus = val;
        this.setLocalAudio(val, notNeedChange);
      }
    },
    async setLocalAudio(value, notNeedChange, origin) {
      let operationResult = 'success';
      const type = value ? 'publish' : 'unpublish';
      const rtc = this.rtc[this.realPartyCode];
      if (value) {
        if (rtc && rtc._localAudioTrack) {
          operationResult = await controlDevicePublish(rtc, 'publish', [rtc._localAudioTrack]);
        } else {
          // 初始化的时候没有本地音频轨道，需要重新获取
          controlAudio(rtc, this.devicesInfo, value, result => {
            if (result == 'failed') operationResult = 'failed';
          });
        }
      } else {
        operationResult = await controlDevicePublish(rtc, type, [rtc._localAudioTrack]);
      }
      if (operationResult === 'success') {
        controlDeviceBehavior({
          senderRtilCode: this.userInfo.rtilCode,
          type: 'mic',
          value,
          partyCode: this.userInfo.joinCode,
          toRtilCode: this.userInfo.rtilCode,
          changeState: true
        });
        if (origin == 'host') {
          this.$set(this.State.micStatus, this.userInfo.rtilCode, value);
          this.$message.warning(value ? this.$t('remainWords.hostHasMicrophoneOn') : this.$t('commonFunction.hasMicrophoneOff'));
        }
      } else {
        this.$set(this.State.micStatus, this.userInfo.rtilCode, value);
        if (notNeedChange) this.oldMuteMicStatus = value;
        this.$message.warning(this.$t('common.operationFailed'));
        if (origin == 'host') {
          this.$message.warning(this.$t('common.hostOperationMicroFailed'));
          // 操作失败，给host发送消息
          this.sendToHost('mic', 3);
        }
      }
    },
    setEnabledFn(value, type, origin) {
      const rtc = this.rtc[this.realPartyCode];
      if (!rtc) return;
      rtc.setEnabled(value, type, info => {
        if (info === 'failed') {
          if (type == 'video') {
            this.$set(this.State.cameraStatus, this.userInfo.rtilCode, value);
          }
          if (origin == 'host') {
            this.$message.warning(this.$t(`common.${type == 'audio' ? 'hostOperationMicroFailed' : 'hostOperationCameraFailed'}`));
            // 操作失败，给host发送消息
            this.sendToHost(type == 'audio' ? 'mic' : 'camera', 3);
          } else {
            this.$message.warning(this.$t('common.operationFailed'));
          }
        }
        if (info == 'success') {
          controlDeviceBehavior({
            senderRtilCode: this.userInfo.rtilCode,
            type: 'camera',
            value: value,
            partyCode: this.userInfo.joinCode,
            toRtilCode: this.userInfo.rtilCode,
            changeState: true
          });
          if (origin == 'host') {
            if (value) {
              this.CameraTips.hideCancel = true;
              this.CameraTips.hideSave = true;
              this.CameraTips.showGotIt = true;
              this.CameraTips.show = true;
              this.CameraTips.content = `<div class="end">${this.$t('commonFunction.hasCameraOff')}</div>`;
            }
          }
        }
      });
    },
    changeBehaviorStatus(key, value) {
      if (!this.userInfo.rtilCode || !this.$route.query.id) return;
      // 更新状态
      const params = [{
        mark: this.userInfo.rtilCode + '',
        annotation: this.$route.query.id,
        key,
        value: !value
      }];
      this.axios.post('/partyline-backend/behavior/noLogin/setList', params).then(res => {});
    },
    getChatMettingInfo(result) {
      const externalList = result.externalJoinInfo.externalPartyInfo;
      externalList.map(async v => {
        const {
          appId,
          tokenCode,
          rtilCode,
          realPartyCode,
          videoQualities
        } = v.joinInfo;
        const params = {
          appId: appId,
          channel: realPartyCode + '',
          token: tokenCode,
          uid: rtilCode,
          cameraId: this.devicesInfo.cameraId,
          microphoneId: this.devicesInfo.microphoneId,
          videoConfig: videoQualities,
          video: false,
          audio: false,
          executeLocalSubscribe: true,
          executeVideoAdded: true
        };
        this.rtc[realPartyCode] = new AgoraClient(this.callBack);
        const uid = await this.rtc[realPartyCode].join(params);
        if (uid) {
          this.rtcLoaded = true;
        }
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    Bus.$off('initDevices');
    window.removeEventListener('resize', this.calculatorArea);
    // document.removeEventListener('fullscreenerror', this.showFullScreenTips)
    if (this.onlineTimer) clearInterval(this.onlineTimer);
    if (this.rtc) {
      for (const k in this.rtc) {
        this.rtc[k] && this.rtc[k].leave(this.hadOpenWebCloud ? 'closeCLoudProxy' : '');
        if (this.sendMetadataTimer[k]) clearInterval(this.sendMetadataTimer[k]);
      }
    }
    this.socket && this.socket.close();
    if (this.updataInfoTimer) clearInterval(this.updataInfoTimer);
    this.State.crewInfo = {};
    this.State.privateInfo = {};
    if (this.ckeckStatusTimer) clearTimeout(this.ckeckStatusTimer);
    this.shareRtc && this.shareRtc.leave();
    if (this.State.pageSerBusRequestWs[this.State.partyCode]) {
      this.State.pageSerBusRequestWs[this.State.partyCode].close(); // 手动停止websocket
      this.State.pageSerBusRequestWs[this.State.partyCode] = null;
    }
    // 为了 Global Control 添加
    if (this.State.pageSerBusRequestWs[this.globalControlId]) {
      this.State.pageSerBusRequestWs[this.globalControlId].close(); // 手动停止websocket
      this.State.pageSerBusRequestWs[this.globalControlId] = null;
    }
    Bus.$off('setLoginScreenButton');
    next();
  }
};